/**
 * Converts Trix links into using target as _blank to open a new window.
 *
 * Example: %div{ data: {controller: "trix--editor trix--new-window-link"} }
 *
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.querySelectorAll("a").forEach(function (link) {
      if (link.host !== window.location.host) {
        link.target = "_blank";
        link.rel = "noopener noreferrer";
      }
    });
  }
}
